import { gql, useMutation } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { getWorkflow, updateWorkflow } from '../ducks';
import { WorkflowType } from '../enums';

export const enabledJourneyTracking = gql`
  mutation enableJourneyTracking($id: Long!) {
    success: enableVisitorTrackingForWorkflow(id: $id)
  }
`;

export const disableJourneyTracking = gql`
  mutation disableJourneyTracking($id: Long!) {
    success: disableVisitorTrackingForWorkflow(id: $id)
  }
`;

type ToggleJourneyTrackingResponse = {
  success?: number;
};

const FAILURE_MESSAGE = `Error updating published journey options. Please try again later.`;

export const useJourneyVisitorTracking = () => {
  const dispatch = useDispatch();
  const workflow = useSelector(getWorkflow);
  const [enable] = useMutation<ToggleJourneyTrackingResponse>(enabledJourneyTracking);
  const [disable] = useMutation<ToggleJourneyTrackingResponse>(disableJourneyTracking);

  const setJourneyVisitorTracking = async (id?: number, enabled?: boolean) => {
    const mutateFn = enabled ? enable : disable;

    try {
      const { data } = await mutateFn({ variables: { id } });
      if (data?.success === 1) {
        const dataToUpdate =
          workflow.workflowType === WorkflowType.PUBLISHED
            ? { visitorTrackingEnabled: enabled }
            : {
                workflowReference: {
                  ...workflow.workflowReference,
                  visitorTrackingEnabled: enabled,
                },
              };
        dispatch(
          updateWorkflow(
            {
              ...(dataToUpdate as any),
            },
            { suppressHasUnsavedChangesUpdate: true },
          ),
        );
        return { hasErrors: false };
      } else {
        dispatch(addNegativeToastWithErrorId(FAILURE_MESSAGE, 'useJourneyVisitorTracking'));
        return { hasErrors: true };
      }
    } catch {
      dispatch(addNegativeToastWithErrorId(FAILURE_MESSAGE, 'useJourneyVisitorTracking'));
      return { hasErrors: true };
    }
  };
  return setJourneyVisitorTracking;
};
